import {inject, Injectable, signal, WritableSignal} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {
    BmwOasisCloudUsrDetailsResponse,
    UserIdentity,
    UserInfo,
    UserInfoHeader,
    UserInfoRFCRequest,
} from '../models/user-info.model';
import {AuthConfig} from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class UserInfoService {
  private readonly AMBaseURL: string = AuthConfig.AMBaseURL;


  private readonly http = inject(HttpClient);

  userInfo: WritableSignal<UserInfoHeader> = signal({
    username: 'Loading...',
    department: '',
    profileImg: '',
  });

  userIdentity: WritableSignal<UserIdentity | null> = signal(null);


  getUserInfo(accessToken?: string): Observable<UserInfo> {
    const token = accessToken ?? this.getAccessTokenFromCookie();
    if (!token) {
      return throwError(() => new Error('Missing access token'));
    }

    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    const url = `${this.AMBaseURL}/oauth2/${AuthConfig.realmPath}/userinfo`;

    return this.http
      .get<UserInfo>(url, { headers })
      .pipe(catchError(this.handleError));
  }

  private getAccessTokenFromCookie(): string | null {
    const cookieName = 'access_token_sms=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieParts = decodedCookie.split(';');

    for (let part of cookieParts) {
      part = part.trim();
      if (part.indexOf(cookieName) === 0) {
        return part.substring(cookieName.length, part.length);
      }
    }

    return null;
  }

  getFullNamesRFC(
    requestPayload: UserInfoRFCRequest
  ): Observable<BmwOasisCloudUsrDetailsResponse> {
    const url = '/user/userInfo';
    return this.http
      .post<BmwOasisCloudUsrDetailsResponse>(url, requestPayload)
      .pipe(catchError(this.handleError));
  }

  setIdentity(userInfo: UserInfo): void {
    this.userIdentity.set({
      userId: userInfo.sub,
      userName: userInfo.name || '',
    });
  }

  clearIdentity(): void {
    this.userIdentity.set(null);
  }

  getUserId(): string {
    return this.userIdentity()?.userId || '';
  }

  getUserName(): string {
    return this.userIdentity()?.userName || '';
  }

  private handleError(error: unknown): Observable<never> {
    console.error('An error occurred:', error);
    return throwError(
      () => new Error('Something went wrong; please try again later.')
    );
  }
}
